import React, { type ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import MarkResponse from 'feature-components/mark-response';
import MainLayout from 'layouts/main';
import { MarkingPath } from 'pages/marking/routes';
import { goBack } from 'utils/goBack';
import Breadcrumbs from './breadcrumbs';

export default function MarkResponsePage(): ReactElement {
  const navigate = useNavigate();
  const redirectToMarkerDashboard = useCallback(() => {
    // Attempt to navigate the previous URL (so that we preserve Marker Dashboard filters). This
    // will also return the Marking Admin to the Marks to Review page if they arrived from there.
    goBack(
      () => navigate(-1),
      () => navigate(MarkingPath.MarkerDashboard)
    );
  }, [navigate]);

  return (
    <MainLayout title="Marking" breadcrumbs={<Breadcrumbs />}>
      <MarkResponse onSave={redirectToMarkerDashboard} />
    </MainLayout>
  );
}
